import { Component, OnInit } from '@angular/core';
import { AwardService } from '../../../../core/services/awards/awards.service';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-awards',
    templateUrl: './awards.component.html',
    styleUrls: ['./awards.component.scss']
})
export class AwardsComponent implements OnInit {
    awardsList: any=[];
    isSideBarOpen:boolean=false;
    version: any = [];
    allVersions: any = [];
    isArchive:boolean=false;
    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        autoWidth: true,
        pullDrag: true,
        dots: true,
        merge: false,
        navSpeed: 700,
        responsive: {
          0: {
            items: 1
          },
          400: {
            items: 1
          },
          500:{
            items: 2
          },
          940: {
            items: 3
          },
          1200:{
            items: 4
          },

          1800: {
            items: 6
          }
        }
      }
    constructor(public awardService: AwardService, private router: Router) { }

    ngOnInit(): void {
        if(this.router.url.includes('/archive')){
            this.isArchive = true;
        }
        this.getAllVersion()
        this.awardService.getAwardsHome().subscribe((res) => {
            this.awardsList = res;
            this.awardsList.awardsBanner.push({
                "id": 9,
                "category": "jury112312",
                "award": "CINEJOY JURY",
                "award_message1": "Meet the luminaries judging the awards!",
                "award_message2": "test1",
                "thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "mobile_thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "movie_link": this.isArchive ? "/cinejoy/archive/jury" :"/cinejoy/jury",
                "award_version": "1",
                "type": "Jury"
            })
        }, err => {

        })
    }

    onToggleSideNav(){
        this.isSideBarOpen = !this.isSideBarOpen;
    }

    navigateAllAwards(){
        if(this.isArchive){
            this.router.navigate(['/cinejoy/archive/all-awards'])

        }else{
            this.router.navigate(['/cinejoy/all-awards'])
        }
    }

    goToLink(url: string, type?:any){
        if(type === 'Jury'){
            window.open(url);
        }else{
            if (/(http(s?)):\/\//i.test(url)) {
                window.open(url, "_blank");
            } else {
                window.open(`https://${url}`);
            }
        }

    }

    getAllVersion() {
        this.awardService.getAllAwardsVersion().subscribe(data => {
            this.allVersions = data.awardsVersions;
            this.version = this.allVersions.find((v) => v.isCurrent == 1)['id'];
        }, err => {

        })
    }

    onChangeVersion(event: any) {
        this.awardService.getArchivedHomePageByVersion(this.version).subscribe((res) => {
            this.awardsList = res;
            this.awardsList.awardsBanner.push({
                "id": 9,
                "category": "jury112312",
                "award": "CINEJOY JURY",
                "award_message1": "Meet the luminaries judging the awards!",
                "award_message2": "test1",
                "thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "mobile_thumbnail": "../../../../../assets/images/behind-the-scenes.jpg",
                "movie_link": "/cinejoy/jury",
                "award_version": "1",
                "type": "Jury"
            })
        }, err => {

        })
    }
}